import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getActivityQueryOptions } from '@/features/auth/api/use-get-activity';
import httpService from '@/lib/http.service';
import { MutationConfig } from '@/lib/react-query';

export interface UpdateActivityPayload {
  timestamp: number;
}

export const updateActivity = ({ timestamp }: UpdateActivityPayload) => {
  return httpService.patch(`/self-service/auth/activity`, { timestamp });
};

type UseUpdateActivityOptions = {
  mutationConfig?: MutationConfig<typeof updateActivity>;
};

export const useUpdateActivity = ({ mutationConfig }: UseUpdateActivityOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      queryClient.refetchQueries({
        queryKey: getActivityQueryOptions().queryKey,
      });
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: updateActivity,
  });
};
